// Phase I4.2 — map a hierarchical tier code to the binary "effective tier"
// the Daily Acca surface cares about: free vs pro.
//
// The Daily Acca only has two SKUs (3-leg free / 5-leg pro). Anything in
// the Pro hierarchy (sika_pro, phantom_pro, desk_pro, plus legacy
// aliases handled in tier-gates.ts) collapses to 'pro'. Everything else,
// including null/undefined for anon, collapses to 'free'.

import { tierMeets } from "../auth/tier-gates.ts";

export type EffectiveTier = "free" | "pro";

export function getEffectiveTier(tierCode: string | null | undefined): EffectiveTier {
  if (tierCode === null || tierCode === undefined) return "free";
  return tierMeets(tierCode, "sika_pro") ? "pro" : "free";
}
